module.exports = __webpack_public_path__ + "Banner_LifehackLessons-4fe5200386e1631de67189b26212dae3.svg";